import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Modal,
} from 'react-bootstrap';

import { cloneDeep, filter, map } from 'lodash';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import ShipmentStore from 'stores/ShipmentStore';
import ProTip from '../../ui/ProTip';
import CarrierGroup from './CarrierGroup';
import { getShipmentEquipment } from '../../../helpers/shipments';
import i18next,{ withTranslation } from 'react-i18next';
import {titleize} from 'underscore.string'


class BulkUpdateCarrierCostModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      proTipVisible: true,
      carrierGroups: [],
      disableSave: true,
      disableSaves: [],
      shipmentUpdates: {},
    };
  }

  componentDidMount() {
    this.initModalData(this.props);
    ShipmentStore.addChangeListener(this.handleShipmentsQueryUpdate);
    ShipmentStore.addBulkShipmentUpdateChangeListener(this.handleBulkShipmentUpdateChange);
  }

  componentWillUnmount() {
    ShipmentStore.removeChangeListener(this.handleShipmentsQueryUpdate);
    ShipmentStore.removeBulkShipmentUpdateChangeListener(this.handleBulkShipmentUpdateChange);
  }

  getShipmentMetadata = (shipments) => {
    const shipmentUpdates = shipments
      .reduce((current, shipment) => {
        if (shipment.order && shipment.order._id) {
          const carrierCost = shipment.payables.find((adj) => adj.type === 'carrier_cost');
          let equipment;
          let reason;

          if (carrierCost) {
            equipment = carrierCost.equipment;
            reason = carrierCost.reason;
          }
          const {
            _id,
            carrier_cost,
          } = shipment;
          return {
            ...current,
            [_id]: {
              _id,
              carrier_cost,
              equipment,
              reason,
              meta: {
                carrier_cost,
                equipment,
                reason
              },
            },
          };
        }
        return current;
      }, {});

    return shipmentUpdates;
  }

  initModalData(props) {
    const { shipments } = props;

    ShipmentsActionCreators.getShipmentsById({ shipments });
  }

  handleHide = () => this.props.onHide();

  handleShipmentsQueryUpdate = async () => {
    const selectedShipments = ShipmentStore.getShipmentsForBulkUpdate() || [];
    const shipments = selectedShipments.filter(s => s.carrier);
    const disableSaves = map(shipments, '_id') || []
    if (shipments.length > 0) {
      const shipmentUpdates = this.getShipmentMetadata(shipments);
      const carrierGroups = groupShipmentsByCarrier(shipments);
      this.setState({ carrierGroups, disableSaves, shipmentUpdates });
    }
  }

  handleEquipmentChange = (shipmentId, equipment) => {
    this.setState((prevState) => {
      const {
        shipmentUpdates: currentShipmentUpdates,
      } = prevState;
      const target = cloneDeep(currentShipmentUpdates[shipmentId]);
      target.meta.equipment = equipment;

      const shipmentUpdates = {
        ...currentShipmentUpdates,
        [shipmentId]: target,
      };

      return {
        shipmentUpdates,
      };
    });
  }

  handleCarrierCostChange = (shipmentId, carrierUpdates) => {
    this.setState((prevState) => {
      var {
        shipmentUpdates: currentShipmentUpdates,
        disableSaves,
      } = prevState;
      const target = cloneDeep(currentShipmentUpdates[shipmentId]);
      target.meta.carrier_cost = carrierUpdates.carrierCost;
      target.meta.reason = carrierUpdates.reason;
      const shipmentUpdates = {
        ...currentShipmentUpdates,
        [shipmentId]: target,
      };

      if(carrierUpdates && carrierUpdates.reason && carrierUpdates.reason !== null && carrierUpdates.reason.length > 0){
        disableSaves = filter(disableSaves, function(id){return id !== shipmentId})
      }else{
        if(!disableSaves.includes(shipmentId)){
          disableSaves.push(shipmentId)
        }
      }
      return {
        disableSave: carrierUpdates.reason ? (carrierUpdates.reason === null || carrierUpdates.reason.length === 0) : true,
        disableSaves: disableSaves,
        shipmentUpdates,
      };
    });
  }

  handleSaveAll = () => {
    const {
      shipmentUpdates,
    } = this.state;
    const updates = Object
      .values(shipmentUpdates)
      .filter(update => (update.reason !== update.meta.reason) || (update.carrier_cost !== update.meta.carrier_cost) || (update.equipment !== update.meta.equipment))
      .map(update => ({
        _id: update._id,
        carrier_cost: update.meta.carrier_cost,
        reason: update.meta.reason,
        equipment: update.meta.equipment,
      }));

    ShipmentsActionCreators.bulkUpdateCarrierCosts({ updates });
  }

  handleRemoveShipment = (carrierId, shipmentId) => {
    this.setState((prevState) => {
      const {
        carrierGroups: currentCarrierGroups,
        shipmentUpdates: currentShipmentUpdates,
      } = prevState;

      const { [shipmentId]: deletedKey, ...shipmentUpdates } = currentShipmentUpdates;
      const groupIndex = currentCarrierGroups.findIndex(g => g.id === carrierId);

      const carrierGroup = cloneDeep(currentCarrierGroups[groupIndex]);

      const shipmentIndex = carrierGroup.shipments.findIndex(s => s._id === shipmentId);

      const currentShipments = carrierGroup.shipments;
      carrierGroup.shipments = [
        ...currentShipments.slice(0, shipmentIndex),
        ...currentShipments.slice(shipmentIndex + 1),
      ];

      const carrierGroups = [
        ...currentCarrierGroups.slice(0, groupIndex),
        carrierGroup,
        ...currentCarrierGroups.slice(groupIndex + 1),
      ];

      return {
        carrierGroups,
        shipmentUpdates,
      };
    });
  }

  handleApplyToAll = (targetShipmentId) => {
    this.setState((prevState) => {
      var {
        shipmentUpdates: currentShipmentUpdates,
      } = prevState;

      const update = currentShipmentUpdates[targetShipmentId];

      const {
        meta: {
          carrier_cost,
          reason,
          equipment,
        },
      } = update;
      const shipmentUpdates = Object.keys(currentShipmentUpdates).reduce((updates, shipmentId) => {
        return {
          ...updates,
          [shipmentId]: {
            ...currentShipmentUpdates[shipmentId],
            meta: {
              carrier_cost,
              reason,
              equipment,
            },
          },
        };
      }, {});
      return {
        disableSaves: [],
        disableSave: false,
        shipmentUpdates,
      };
    });
  }

  handleBulkShipmentUpdateChange = () => {
    this.handleHide();
  }

  renderProTip() {
    const {t} = this.props;
    if (!this.state.proTipVisible) {
      return null;
    }
    if (!this.state.carrierGroups.length) {
      return (
        <div className="mb-4">
          <ProTip
            message={t('ASSIGN_CARRIER_BEFORE_CARRIER_COST_UPDATE_TIP')}
            onClose={this.handleCloseTip}
          />
        </div>
      );
    }

    return (
      <div className="mb-4">
        <ProTip
          message={t('ENSURE_INFO_FILLED_BEFORE_APPLY_ALL')}
          onClose={this.handleCloseTip}
        />
      </div>
    );
  }

  render() {
    const {
      show,
      t,
    } = this.props;

    const {
      carrierGroups,
      shipmentUpdates,
      saving,
    } = this.state;

    const disableSaves = !!(this.state.disableSaves && this.state.disableSaves.length)
    return (
      <Modal
        show={show}
        onHide={this.handleHide}
        backdrop="static"
        dialogClassName="modal-override"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{titleize(t('UPDATE_CARRIER_COST'))}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="-m-4 p-4 bg-gray-100 overflow-y-auto"
            style={{ maxHeight: '80vh' }}
          >
            {this.renderProTip()}
            {carrierGroups.map((group) => (
              <CarrierGroup
                carrierGroup={group}
                saving={saving}
                shipmentUpdates={shipmentUpdates}
                onCarrierCostChange={this.handleCarrierCostChange}
                onEquipmentChange={this.handleEquipmentChange}
                onApplyToAll={this.handleApplyToAll}
                onRemoveShipment={this.handleRemoveShipment}
                onSaveAll={this.handleSaveAll}
                disableSave={disableSaves || this.state.disableSave}
                disableSaves={this.state.disableSaves}
                key={group.id}
              />
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex justify-end">
            <div className="md:w-1/4 mt-3">
              <div className="flex justify-end button-group">
                <button
                  className="block button secondary-action"
                  onClick={this.handleHide}
                >
                  {titleize(t('CLOSE'))}
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

BulkUpdateCarrierCostModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  shipments: PropTypes.array,
};

function groupShipmentsByCarrier(shipments) {
  const noCarrier = {
    _id: -1,
  };

  const groupMap = shipments.reduce((group, shipment) => {
    const carrier = shipment.carrier || noCarrier;
    const {
      _id: carrierId,
    } = carrier;


    const {
      equipment,
      ...currentShipment
    } = shipment;

    currentShipment.equipments = getShipmentEquipment(shipment);
    if (group[carrierId]) {
      const carrierGroup = group[carrierId];
      carrierGroup.shipments.push(currentShipment);
      return {
        ...group,
        [carrierId]: carrierGroup,
      };
    }
    const name = currentShipment.carrier_name || i18next.t('NO_CARRIER');
    return {
      ...group,
      [carrierId]: {
        id: carrierId,
        name,
        shipments: [currentShipment],
      },
    };
  }, {});

  return Object.values(groupMap);
}


export default withTranslation()(BulkUpdateCarrierCostModal);
